import { niTrackEvent } from '@xsite-ui/common.event-tracker';

function initFooterScripts() {
  initBackToTop();
  initFooterUiEvents();
}

function initBackToTop() {
  var backToTopButton = document.querySelector('[data-role="back-to-top"]');

  if (!backToTopButton) {
    return;
  }

  backToTopButton.addEventListener('click', function backToTopClick(event) {
    event.preventDefault();
    scrollToTop();
  });
}

function scrollToTop() {
  var distanceToTop = document.documentElement.scrollTop || document.body.scrollTop;

  if (distanceToTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollBy(0, -100);
  }
}

function initFooterUiEvents() {
  var _document$querySelect;

  var bucketName = (_document$querySelect = document.querySelector('body')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.dataset.name;
  var footer = document.querySelector('[data-role="main-footer"]');
  var checkFooterImpression = throttle(function throttleCb() {
    if (isInViewport(footer)) {
      niTrackEvent({
        category: 'viewable impression',
        action: 'impression',
        optLabel: "footer in view, page: ".concat(bucketName),
        optValue: 1,
        optNonInteraction: true
      });
      document.removeEventListener('scroll', checkFooterImpression);
    }
  });
  document.addEventListener('scroll', checkFooterImpression, {
    passive: true
  });
}

function throttle(action) {
  var isRunning = false;
  return function throttleFunc() {
    if (isRunning) {
      return;
    }

    isRunning = true;
    window.requestAnimationFrame(function animFrame() {
      action();
      isRunning = false;
    });
  };
}

function isInViewport(element) {
  var rect = element.getBoundingClientRect();
  return rect.top >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight);
}

export { initFooterScripts };
